import { useEffect, useRef, useState } from "react";
import api from "../lib/api";
import { Label } from "./ui/label";
import { Button } from "./ui/button";
import { Loader2, Upload, Trash2 } from "lucide-react";

export function ProfileImageField({ label, kind, path, busy, onUpload, onDelete, circle }) {
  const inputRef = useRef(null);
  const [src, setSrc] = useState(null);

  useEffect(() => {
    let obj = null;
    if (path) {
      api
        .get(`/files/${path}`, { responseType: "blob" })
        .then((res) => {
          obj = URL.createObjectURL(res.data);
          setSrc(obj);
        })
        .catch(() => setSrc(null));
    } else {
      setSrc(null);
    }
    return () => {
      if (obj) URL.revokeObjectURL(obj);
    };
  }, [path]);

  return (
    <div className="space-y-2">
      <Label className="text-xs tracking-[0.15em] uppercase text-white/50">{label}</Label>
      {path ? (
        <div className="flex items-center gap-4">
          <div
            className={`bg-white border border-white/15 overflow-hidden flex items-center justify-center shrink-0 ${
              circle ? "rounded-full h-16 w-16" : "rounded-lg h-16 w-28 p-1.5"
            }`}
          >
            {src ? (
              <img
                src={src}
                alt={label}
                className={circle ? "h-full w-full object-cover" : "max-h-full max-w-full object-contain"}
                data-testid={`${kind}-thumb`}
              />
            ) : (
              <Loader2 className="h-4 w-4 animate-spin text-black/40" />
            )}
          </div>
          <div className="flex gap-2">
            <Button
              type="button"
              size="sm"
              variant="outline"
              onClick={() => inputRef.current?.click()}
              disabled={busy}
              data-testid={`${kind}-change`}
              className="h-9 border-white/20 bg-transparent text-white hover:bg-white/10 rounded-lg"
            >
              {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Change"}
            </Button>
            <Button
              type="button"
              size="sm"
              variant="outline"
              onClick={onDelete}
              disabled={busy}
              data-testid={`${kind}-delete`}
              className="h-9 border-[#ff3b30]/40 bg-transparent text-[#ff3b30] hover:bg-[#ff3b30]/10 rounded-lg"
            >
              <Trash2 className="h-4 w-4" />
            </Button>
          </div>
          <input
            ref={inputRef}
            type="file"
            accept="image/*"
            className="hidden"
            onChange={(e) => onUpload(e.target.files?.[0])}
            data-testid={`upload-${kind}-input`}
          />
        </div>
      ) : (
        <label className="flex items-center gap-3 bg-black/40 border border-white/15 border-dashed rounded-lg px-4 h-11 cursor-pointer hover:border-white/30 transition-colors w-fit pr-6">
          {busy ? <Loader2 className="h-4 w-4 animate-spin text-white/50" /> : <Upload className="h-4 w-4 text-white/50" />}
          <span className="text-sm text-white/60">Upload {kind === "logo" ? "logo image" : "headshot photo"}</span>
          <input
            type="file"
            accept="image/*"
            className="hidden"
            onChange={(e) => onUpload(e.target.files?.[0])}
            data-testid={`upload-${kind}-input`}
          />
        </label>
      )}
    </div>
  );
}
